import React from "react";
import "./css/Policy.css";
const Terms = () => {
  return (
    <>
      <div className="container mb-5">
        <h1 style={{ textAlign: "center" }}>TERMS OF USE</h1>
        <span style={{ marginTop: 20 }}>
          <p style={{ textAlign: "justify" }}>
            <b>
              This document/agreement/understanding is a computer-generated
              electronic record published in terms of Rule 3 of the Information
              Technology (Intermediary Guidelines and Digital Media Ethics Code)
              Rules, 2021 (amended from time to time) read with Information
              Technology Act, 2000 (amended from time to time) and does not
              require any physical or digital signatures.
            </b>
          </p>
        </span>
        <p style={{ textAlign: "justify" }}>
          These Terms and Conditions (“Terms”) constitute a legal agreement
          between You and InstaPe Synergies Private Limited, a company
          incorporated under Companies Act 2013
          <b> (“InstaPe” or “us”, or “we” or “our”).</b>
        </p>
        <p style={{ textAlign: "justify" }}>
          The Terms, constituted of <b>Part A: General Terms and Conditions</b>{" "}
          and
          <b>Part B: Specific Terms and Conditions,</b> govern Your access to
          and use of InstaPe services, including facilitation to various
          Financial Products offered by Merchants, technology, software,
          analytics or any other services, tools or products offered or made
          available by InstaPe and/or its Affiliates, and/or their Merchants,{" "}
          <b>(“Services”)</b>.
        </p>
        <p style={{ textAlign: "justify" }}>
          The Services may be offered or made available to You via our website,
          mobile applications, software, APIs, social media, or other access
          channels <b>(“InstaPe App”)</b>.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“You”, “Yours”, “Yourself”</b> refers to customers, who register
          for, use, or access the InstaPe App or Services.
        </p>
        <p style={{ textAlign: "justify" }}>
          The Services provided by InstaPe through the InstaPe App are available
          and are appropriate only for use in India.
        </p>
        <p style={{ textAlign: "justify" }}>
          These terms including annexures and links herein, apply to your use of
          Financial Products Facilitation Services on InstaPe App and, any other
          linked pages, API keys, features, content or application services
          (including but without limitation to any mobile application, mobile
          site services) owned and operated by <b>InstaPe</b>.
        </p>
        <p style={{ textAlign: "justify" }}>
          By using InstaPe App, software, services, and the Website or by
          availing any products offered by InstaPe's Merchants, You understand
          and agree that InstaPe will treat Your use of the Services as
          acceptance of these Terms from such point of usage.
        </p>
        <p style={{ textAlign: "justify" }}>
          You agree that InstaPe reserves the right to update the Services from
          time to time.
        </p>
        <p style={{ textAlign: "justify" }}>
          You may not use the Services if You do not accept the Terms.
        </p>
        <p style={{ textAlign: "justify" }}>
          It is strongly recommended for You to return to this link periodically
          to review the most current version of the Terms in force. InstaPe
          reserves the right at any time, at its sole discretion, to change or
          otherwise modify the Terms without prior notice, and Your continued
          access or use of the InstaPe App signifies Your assent/ratification of
          the updated or modified Terms.
        </p>
        <p style={{ textAlign: "justify" }}>
          If You object to these Terms or any subsequent modifications to these
          Terms in any way, Your only recourse is to immediately terminate use
          of the InstaPe App.
        </p>
        <p style={{ textAlign: "justify" }}>
          We may require You to agree to additional terms in connection with
          specific Services, provided either by InstaPe or its Merchant, that
          You may avail from time to time.
        </p>
        <p style={{ textAlign: "justify" }}>
          You agree to be bound by supplemental terms of any specific Service
          that You access or use via our InstaPe App and/or are available by
          hyperlink on our InstaPe App. We may ask You to agree to those
          supplemental terms by way of ‘acceptance’.
        </p>
        <p style={{ textAlign: "justify" }}>
          You further agree that any claims relating to any specific Financial
          Product shall be brought solely against the Merchant which whom such
          product is availed by You.
        </p>
        <p style={{ textAlign: "justify" }}>
          You hereby give your consent for us to store and use the
          data/information You provide on the InstaPe App during (i) the initial
          sign up/registration process and (ii) registration or onboarding for
          any specific Service in future.
        </p>
        <p style={{ textAlign: "justify" }}>
          Before You may use the InstaPe App, You must read all of these General
          Terms of Use and the Specific Terms of Use (hereinafter together
          referred to as the <b>“Terms”</b> and the <b>Privacy Policy</b>{" "}
          provided on the InstaPe App
        </p>
        <p style={{ textAlign: "justify" }}>
          We strongly recommend You read all the terms of use and Privacy Policy
          of the relevant Merchant before continuing to access the link to their
          platform.
        </p>
        <p style={{ textAlign: "justify" }}>
          We strongly recommend You read all the specific product terms before
          availing any of the Financial Products offered by Merchants.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>1. DEFINITIONS AND INTERPRETATION</b> <br></br> <br></br>
          <b>“Applicable Law”</b> shall mean any statute, law, regulation,
          ordinance, rule, judgment, order, decree, by-law, approval from the
          concerned authority, government resolution, directive, guideline,
          policy, requirement, or other governmental restriction or any similar
          form of decision, or determination by, or any interpretation, or
          adjudication having the force of law or any of the foregoing.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Force Majeure Event”</b> shall mean any event due to any cause
          beyond the reasonable control of a Party, including, without
          limitation, unavailability of any communication system, transmitters,
          sabotage, fire, vandals, flood, explosion, hacking, pandemic,
          lockdowns, acts of God, civil commotion, strikes or industrial action
          of any kind, riots, insurrection, strike, embargo, war or acts of
          government;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Intellectual Property”</b> means ideas, concepts, algorithms,
          software programs, patents, registered designs, trademarks and service
          marks, copyright, database right, source codes, design right and moral
          right, in each case existing or pending registration/approval in any
          jurisdiction in the world, and other property rights in other
          jurisdictions that grant similar rights as the foregoing, including
          those subsisting in inventions, drawings, performances, software,
          databases, business names, goodwill and the style of presentation of
          goods and services and in applications for the protection thereof.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Privacy Policy”</b> shall mean the privacy policy of InstaPe, as
          provided on the website and InstaPe App;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Financial Products”</b> shall mean financial products offering on
          the InstaPe App by the Merchants from time to time and may include
          which may include Loan Products, , fixed deposits or other such like
          financial products.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Loan Products”</b> shall mean any advance against any earned
          amount of salary or wages at any point of time or to avail loan
          facility at an agreed rate of interest and processing fees under any
          facility extended by any Merchant on the InstaPe App.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Merchant”</b> shall mean and include Financial Institutions (such
          as Banks and Non-Banking Financial Companies), Private Enterprises,
          Public Enterprises, Central & State Government Entities, etc which
          with InstaPe has entered into a business arrangement for facilitating
          the provision of various Services.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>“Services”</b> shall mean such services as specified in clause 2
          below
        </p>
        <p style={{ textAlign: "justify" }}>
          The words "we", "us" and "our" refer to InstaPe App/ InstaPe as the
          case may be and shall be construed accordingly;
        </p>
        <p style={{ textAlign: "justify" }}>
          The words “you”, “your” and “user” shall mean the person approved to
          perform transaction(s) on the InstaPe App by InstaPe and shall be
          construed accordingly.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Part A: GENERAL TERMS OF USE </b>
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>1. ACCEPTANCE OF TERMS</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          1.1. Usage of InstaPe App is subject to the Terms governing InstaPe.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          1.2. Use of InstaPe App abides You to these Terms.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          1.3. In addition, when using the InstaPe App, You will be subject to
          all guidelines or rules applicable to InstaPe App that may be posted
          from time to time on the InstaPe App.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          1.4. Usage of InstaPe App shall be deemed to be the acceptance of
          these Terms.{" "}
          <b>
            By checking the box, we assume that your consent is given freely and
            that you understand unambiguously and clearly how we will use your
            data and that you may, at any time, withdraw your consent
          </b>
          .
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>2. DESCRIPTION OF SERVICE AND USAGE</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.1. The InstaPe shall facilitate various services including, but not
          limited to, access to Loan Products (Earned Wage Access, Salary
          Advance, Personal Loans); Savings Products (Recurring Deposits, Fixed
          Deposits, Goal Based Savings); Insurance Products; Health Diagnostics;
          etc to be available for use by You on InstaPe App . These services
          shall be provided by or through the respective Merchant for their
          Financial Products and InstaPe shall only be a facilitator in enabling
          You to access such services on its platform “Financial Products
          Facilitation Services” or “Services”.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.2. You need to sign up for a user account by providing all required
          information in order to access or use the InstaPe App. You agree and
          understand that registration on the platform of InstaPe does not
          itself guarantee your eligibility to avail any of the Financial
          products and that You acknowledge that InstaPe App is only a
          facilitator of services and does not have any obligation or
          responsibility to pay, repay or disburse any amounts in relation to
          the services facilitated on the InstaPe App including but not limited
          the loan against accrued salary facility. You agree that facility
          provided by the InstaPe App pertaining to the loan against accrued
          salary facility shall be subject to the certain criteria and
          qualifications which inter-alia includes Your accrued salary as may be
          informed by Your employer, eligibility criteria set out by Your
          employer, KYC and regulatory checks by the bank, NBFC, lender. InstaPe
          shall not be held responsible for any criteria, disqualification,
          rejection of Your application and repayment of the loan availed
          against accrued salary facility, interest and other processing
          charges, if any.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.3. You also acknowledge that as part of your registration on our
          platform, we will have to do a KYC and other regulatory checks as are
          mandated by the Applicable laws, based on the credentials provided by
          you. You expressly consent InstaPe to rely on the KYC Documents
          provided by You for providing Services. You agree to provide true,
          accurate, current and complete information about Yourself as and when
          prompted by the platform. If You provide any information that is
          untrue, inaccurate, not updated or incomplete (or becomes untrue,
          inaccurate or incomplete), or InstaPe has reasonable grounds to
          suspect that such information is untrue, inaccurate, not updated or
          incomplete, InstaPe shall have the right to immediately suspend or
          terminate Your account and/or refuse any and all current or future use
          of the platform, or any portion thereof, in connection thereto.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.4. InstaPe shall have the right to share the KYC Documents (or the
          information therein) and other related documents with the Merchants or
          governmental authorities or law enforcement agencies, as required
          under the Applicable Laws. You further acknowledge and agree that
          InstaPe reserves the right at all times to monitor, review, retain
          and/or disclose any information in relation to the Service(s) as
          necessary pursuant to satisfy any Applicable Laws, legal process or
          governmental request.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.5. InstaPe shall have the right to demand from You, any (i)
          additional KYC Documents and /or (ii) any KYC related or other
          documents, in its sole discretion and / or as per the Applicable Laws
          or pursuant to requests from governmental authorities, law enforcement
          agencies or Merchants. Your failure to submit the KYC Documents when
          requisitioned shall entitle InstaPe to suspend the Services until You
          submit such KYC Documents.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.6. The usage of the Platform may also require You to provide consent
          for providing Your Personal Information (including but not limited to
          any personal data or sensitive personal data as defined under
          Applicable Laws) or to authorize InstaPe App to derive Your
          data/information from any source or public registry or portal, as may
          be necessary to complete Your profile or Your application on the
          InstaPe App, conduct due diligence on You, undertake KYC checks by
          itself or any other third party and/or to provide You Services through
          this Application.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.7. You explicitly authorise InstaPe to rely on such information and
          You represent and warrant that such information shall be and shall
          remain true and accurate. InstaPe shall adhere to best industry
          practices including information security, data protection and privacy
          law while processing such applications. However, InstaPe shall not be
          liable to You against any liability or claims which may arise out of
          such transactions as any such personal information is being collected,
          used, processed and shared with Your explicit consent.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.8. By using the Services and providing your contact information, you
          consent to receiving information about, and offers for, various
          products and services from InstaPe, Merchants or third parties. These
          communications may occur through various channels, including but not
          limited to telephone, SMS, email, WhatsApp, other messaging services,
          or any other physical, electronic, or digital means. You agree that
          InstaPe may contact you electronically or by phone to gauge your
          interest in specific products and services and to process your
          requests or applications. Additionally, you authorize InstaPe, along
          with its partners, service providers, vendors, and other third
          parties, to contact you for purposes such as (i) presenting or
          soliciting your interest in other products or services from third
          parties, or (ii) sending marketing materials, offers, or other
          information through the Website or via other methods including
          telephone, SMS, email, WhatsApp, or other messaging services or
          digital means. You consent to receiving these communications on the
          phone or mobile number you provided on the website and explicitly
          waive any registration or preferences listed under the Do Not Disturb
          (DND) or National Customer Preference Register (NCPR) in accordance
          with Telecom Regulatory Authority of India (TRAI) regulations.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2.9. You agree and authorize InstaPe to share your information with
          its partner banks, financial institutions, group companies, Merchants,
          Affiliates, vendors, service providers, and other third parties as
          necessary to provide the various products and services you select or
          to offer additional value-added services. You also consent to
          receiving communications via email, telephone, and/or SMS from InstaPe
          or these third parties. You may choose to opt out of this by
          unselecting this box. If you request to opt out of receiving such
          communications or marketing materials in the future, this request will
          only apply prospectively and will not affect data that has already
          been shared by InstaPe with your prior consent.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>3. YOUR OBLIGATIONS</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          3.1. You shall provide complete, correct, honest and current
          information as required by InstaPe on the InstaPe App registration
          page including but not limited to the registration information (“User
          Information”). If You provide any User Information that is untrue,
          inaccurate, not current or incomplete, or if there are reasonable
          grounds to suspect that the User Information provided by You is
          untrue, inaccurate, not current or incomplete, InstaPe reserves the
          right to suspend, terminate, or refuse your current or future use of
          InstaPe App. To the extent that You have provided User Information to
          use the InstaPe App, You represent that You have all rights required
          to provide such User Information and further represent that it is true
          and accurate.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          3.2. All User Information provided by You will be used and processed
          in accordance with these Terms, Privacy Policy and the prevalent
          statutes. You acknowledge and agree that You have been provided with
          unrestricted access to the Privacy Policy and that it is your
          responsibility to read and understand the Privacy Policy. In the event
          You disagree with anything set forth in the Privacy Policy, it is your
          responsibility to bring it to InstaPe’s notice by contacting the
          Grievance Redressal Officer.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>4. YOUR REPRESENTATIONS AND WARRANTIES</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          You explicitly agree, represent and warrant that:{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.1. You can enter into legally binding contracts, are not
          "incompetent to contract" under the Indian Contract Act, 1872 and have
          the capacity to enter into the present contract.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.2. You shall not give access to your respective account to others or
          transfer Your account to anyone else.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.3. You or Your account has not previously been disabled by InstaPe
          for violations of its Terms or policies.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.4. You are not prohibited from using the InstaPe App or the products
          and service under Applicable Laws or orders/directions/judgments of
          courts.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.5. You shall not do anything that is unlawful, misleading,
          discriminatory or fraudulent.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.6. You shall not upload viruses or malicious code, or do anything
          that could disable, overburden or impair the proper working or
          appearance of InstaPe App or interfere with or circumvent the security
          features of the InstaPe App or the products and services or any
          related mobile application, other mobile applications, or the
          internet.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.7. You shall not access or collect data from InstaPe App using
          automated means or attempt to access data for which there is no
          permission to access.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.8. You shall not breach these Terms or any other terms and policies
          that apply to use of InstaPe App.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.9. You agree, undertake and covenant that, during the use of the
          InstaPe App, You shall not use, host, display, upload, modify, amend,
          publish, transmit, update or share any information or content
          including but not limited to User Information that:
          <br />
          <br />
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.1. belongs to another person or entity and in relation to which
            You do not have any right or use such information to create a false
            identity to mislead any person as to the identity or origin of any
            communication
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.2. is grossly harmful, harassing, blasphemous, defamatory,
            obscene, pornographic, paedophilic, libellous, invasive of another
            person's privacy, hateful or racially or ethnically objectionable,
            or encouraging money laundering or gambling, or otherwise unlawful
            in any manner whatsoever.{" "}
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.3. is misleading or false in any way.{" "}
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.4. involves the transmission of ‘junk mail’, ‘chain letters’, or
            unsolicited mass mailing or ‘spamming’.{" "}
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.5. infringes upon or violates any third party's rights
            including, but not limited to, Intellectual Property rights, rights
            of privacy (including without limitation unauthorized disclosure of
            a person's name, e-mail address, physical address, phone number,
            photographs) or rights of publicity.{" "}
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.6. provides instructional information about illegal activities
            such as violating someone's privacy, or providing or creating
            computer viruses and malware such as spyware, worms, trojans, etc.
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.7. tries to gain unauthorized access or exceeds the scope of
            authorized access to InstaPe App or to account information of other
            Users etc.{" "}
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.8. engages in commercial or business activities including but
            not limited to activities for gain, contests, sweepstakes, barter,
            advertising etc.
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.9. interferes with another user's use of the InstaPe App.
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.10. contains software viruses or any other computer codes, files
            or programs designed to interrupt, destroy or limit the
            functionality of any computer resource; or contains any trojan
            horses, worms or other computer programming routines that may
            damage, detrimentally interfere with, diminish value of, covertly
            intercept or steal any system, data or personal information.{" "}
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.11. harms minors in any way.
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.12. threatens the unity, integrity, defense, security or
            sovereignty of India, friendly relations with foreign states, or
            public order or causes incitement to the commission of any
            cognizable offence or prevents investigation of any offence or is
            insulting to any other nation.
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.13. use the services for transmitting information that is
            patently false and untrue, and is written or published in any form,
            with the intent to mislead or harass a person, entity or agency for
            financial gain or to cause any injury to any pers
          </p>
          <p style={{ paddingLeft: 20, textAlign: "justify" }}>
            4.9.14. is a misuse or unauthorized use of the InstaPe App or is a
            use prohibited by law or is unlawful.
          </p>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.10. InstaPe, InstaPe logo, architecture, appearance of the InstaPe
          App, in including the colour patterns and display content, InstaPe
          Intellectual Property are trademarks and assets of InstaPe Synergies
          Private Limited. You agree not to display or use, in any manner, the
          InstaPe trademarks, its assets without InstaPe’s prior permission.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4.11. InstaPe App may display trademark and Intellectual Property of
          Merchants. You agree not to You agree not to display or use, in any
          manner, those trademarks or intellectual property assets, without such
          Merchants’ prior permission.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>5. AUTHENTICATION</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          5.1. During registration on InstaPe App, You may be required to select
          an authentication method such as OTP (One Time Password) or password
          for authenticating yourself. Along with that, You may be required to
          set a PIN for using the InstaPe App. If You are unable to enter the
          correct PIN on opening the InstaPe App or if the authentication
          otherwise fails, the registration will fail. Please note that You will
          be required to use the PIN for transactions done via InstaPe App.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          5.2. You are successfully registered on the InstaPe App only after You
          receive confirmation of the same from InstaPe by way of in-InstaPe App
          notification/communication.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>6. CONFIDENTIALITY AND SECURITY OF REGISTRATION INFORMATION </b>{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          6.1. You are liable entirely for maintaining the confidentiality of
          the User Information viz. PIN and other verification information used
          on the InstaPe App. All activities that occur using the User
          Information or other verification information supplied to or
          established by You with respect to InstaPe App will be Your sole
          responsibility. InstaPe is not liable if the User Information is
          misused by You due to any reason whatsoever.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          6.2. You are responsible not to share information which enables
          access/usage of InstaPe App to any third party. You should immediately
          notify InstaPe of any unauthorized use of the InstaPe App,
          verification information, or any other breach of security. You agree
          that InstaPe will not be liable for any loss or damage arising from
          Your failure to comply with these Terms.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>7. PROPRIETARY RIGHTS</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          7.1. We (and our licensors, as applicable) remain the sole owner of
          all right, title and interest in the Services, including the InstaPe
          App and the website{" "}
          <a className="fw-bold text-primary" href="https://instape.com">
            www.instape.com
          </a>{" "}
          (“website”), including any intellectual property rights which subsist
          in the Services (whether registered or not). InstaPe grants You a
          personal, non-exclusive, non-transferable, limited right to access the
          InstaPe App and make personal use of the website and the Services. You
          shall not remove, obscure, or alter any proprietary rights notices
          (including trademark and copyright notices), which may be affixed to
          or contained within the Services. We reserve all rights not granted
          under the Terms. We (and our licensors, as applicable) retains its
          rights in and to trademarks, trade names, service marks, logos, domain
          names, and other distinctive brand features (“marks”) owned or used by
          us in the course of our business. You do not have the right to use any
          of our marks without explicit consent from us. You shall not download,
          copy, create a derivative work, modify, reverse engineer, reverse
          assemble, transmit or otherwise attempt to discover any source code,
          sell, assign, sub-license, grant a security interest in or otherwise
          transfer any right in the Services or marks. You further acknowledge
          and agree that the Services may contain information that is designated
          confidential by us and You shall not disclose such information without
          our prior written consent.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          7.2. You grant a royalty-free, non-exclusive and revocable approval to
          InstaPe, its Affiliates and Merchants, to store and use Your data,
          information, content, trademarks, logos and any other
          materials/information You upload or make available to us or on the
          InstaPe App <b>(“Your Materials”)</b>. You agree that InstaPe may use
          Your Materials to operate and improve the Application, provide the
          Services, and fulfil InstaPe’s rights and discharge its obligations
          under the Terms and Applicable Law. You agree that InstaPe may use
          Your Materials in its marketing and promotional materials without
          requiring any incremental consent from You. You further agree that
          InstaPe may conduct analytics on Your Materials and that InstaPe shall
          retain ownership of the results or reports derived from such data
          which shall be in aggregated and anonymized form for its business
          purposes in accordance with Applicable Laws. You shall indemnify and
          hold harmless InstaPe, its Affiliates and its Merchants on demand
          against all claims and losses arising out of or in connection with our
          use of Your Materials in accordance with this clause.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>8. MERCHANTS</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          8.1. InstaPe App merely offers a mode to You to do online digital
          transactions with the Merchants. InstaPe, by no means intends to
          endorse any merchant over others. InstaPe does not validate the
          Merchant’s services or offering. Additionally, InstaPe does not
          guarantee You any experience with the Merchant in terms of delivery of
          product, quality etc. Your interaction with the Merchant is
          independent of governance of InstaPe App rules. Please refer to Part
          B: Specific Terms of Use.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          8.2. In no event will You be liable for any loss or damage arising
          from the Merchant’s service or product, including without limitation,
          indirect or consequential loss or damage, purchased using the InstaPe
          App. You are responsible for reading and understanding the Merchant’s
          Terms before accessing or using any merchant or its services.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          8.3. While we will try to provide you with advance notice, whenever
          reasonably possible, you acknowledge and agree that InstaPe may, at
          any time and in our sole discretion, and without any notice to you,
          suspend, restrict or disable access to or remove from the Platform,
          any Merchant, without any liability to you, including without
          limitation for any loss of profits, revenue, data, goodwill or other
          intangible losses.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>9. INTERNET FRAUDS</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          9.1. The internet per se is susceptible to a number of frauds,
          misuses, hacking and other actions which could affect the use of
          InstaPe App. Whilst InstaPe shall actively strive to provide security
          to prevent the same, there cannot be any absolute guarantee from such
          internet frauds, hacking and other actions which could affect the use
          of the InstaPe App. InstaPe will not take liability for any viruses,
          malware or unlawful downloads that Your system may be exposed to while
          You accesses the internet for using InstaPe App. You shall separately
          evaluate all risks arising out of the same.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>10. OPERATIONAL ISSUES</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          10.1. Every effort is made to keep the InstaPe App/website up and
          running smoothly. However, InstaPe will not be held liable for the
          InstaPe App/website being temporarily unavailable due to operational
          issues beyond control of InstaPe.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>11. INDEMNITY AND LIMITATION OF LIABILITY </b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          11.1. YOU EXPRESSLY UNDERSTAND AND AGREE THAT THE USE OF THE SERVICES
          IS AT YOUR SOLE RISK. THE SERVICES ARE PROVIDED ON AN
          AS-IS-AND-AS-AVAILABLE BASIS. INSTAPE EXPRESSLY DISCLAIMS ALL
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
          LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
          A PARTICULAR PURPOSE. INSTAPE MAKES NO WARRANTY THAT THE SERVICES WILL
          BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE. USE OF ANY MATERIAL
          DOWNLOADED OR OBTAINED THROUGH THE USE OF THE SERVICES SHALL BE AT
          YOUR OWN DISCRETION AND RISK AND YOU WILL BE SOLELY RESPONSIBLE FOR
          ANY DAMAGE TO YOUR COMPUTER SYSTEM, MOBILE TELEPHONE, WIRELESS DEVICE
          OR DATA THAT RESULTS FROM THE USE OF THE SERVICES OR THE DOWNLOAD OF
          ANY SUCH MATERIAL. NO ADVICE OR INFORMATION, WHETHER WRITTEN OR ORAL,
          OBTAINED BY YOU FROM INSTAPE, ITS EMPLOYEES OR REPRESENTATIVES SHALL
          CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE AGREEMENT
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          11.2. YOU AGREE TO INDEMNIFY AND HOLD HARMLESS INSTAPE, ITS DIRECTORS,
          SHAREHOLDERS, OFFICERS, EMPLOYEES AND AGENTS, AGAINST ANY CLAIMS,
          LOSSES, DAMAGES OR COSTS ARISING FROM (I) YOUR USE OF THE INSTAPE APP
          AND ITS CONTENTS, (II) YOUR BREACH OF THESE TERMS OR (III) ANY ACTS OR
          OMISSION OF YOURS IN RELATION TO THE INSTAPE APP AND ITS USE THEREOF.
          THE AGGREGATE LIABILITY OF THE INSTAPE TO YOU OR ANYONE, WHETHER IN
          CONTRACT, TORT, NEGLIGENCE OR OTHERWISE, HOWSOEVER ARISING, WHETHER IN
          CONNECTION WITH THESE TERMS, YOUR ACCESS AND USE OF THE INSTAPE APP
          AND ITS CONTENTS AND FUNCTIONALITIES OR FOR ANY REASON RELATED TO THE
          OPERATION OF THE INSTAPE APP, SHALL NOT EXCEED INR 5,000.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          11.3. IN NO EVENT SHALL THE INSTAPE BE LIABLE FOR FAILED TRANSACTIONS
          WHICH ARE INCOMPLETE DUE TO ANY REASON AND ANY LOSS OF PROFITS
          (ANTICIPATED OR REAL), LOSS OF BUSINESS, LOSS OF REPUTATION, LOSS OF
          DATA, LOSS OF GOODWILL, ANY BUSINESS INTERRUPTION OR ANY DIRECT,
          INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, TORT OR OTHER
          DAMAGES, HOWEVER CAUSED, WHETHER OR NOT IT HAS BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>12. DISCONTINUATION OF INSTAPE APP </b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          12.1. InstaPe reserves the right to discontinue the above service at
          any time whatsoever without prior intimation to You.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>13. GRIEVANCE REDRESSAL</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          If You have any complaints/grievances or, You wish to report any issue
          or security incident related to the InstaPe App and other content and
          services, please reach out to our Grievance Redressal Officer by email
          on: nodalofficer@instape.com
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>14. MISCELLANEOUS</b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14.1. Amendments: InstaPe reserves the right to modify this Terms or
          policies including but not limited to Privacy Policy relating to the
          InstaPe App at any time, effective upon posting of an updated version
          of this Terms or the said policies, as the case may be, on the InstaPe
          App. Upon doing so, the revised updated date shall be reflected at the
          bottom of the page containing the Terms or the said policies.
          Continued use of the InstaPe App after any such changes shall
          constitute your consent to such changes to the Terms or said policies.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14.2. Force Majeure: In no event shall InstaPe be held liable for any
          failure to perform any of its obligations, if the performance is
          prevented, hindered or delayed by a Force Majeure Event.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14.3. Waiver: Any failure on the part of InstaPe to require
          performance of any provision of these Terms shall not affect its right
          to full performance thereof at any time thereafter, and any waiver by
          InstaPe of a breach of any provision hereof shall not constitute a
          waiver of a similar breach in the future or of any other breach.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14.4. Governing Law: These Terms are governed by the laws of India.
          You irrevocably consent to the exclusive jurisdiction and venue of the
          competent courts located at Mumbai, Maharashtra, India for all
          disputes arising out of or relating to these Terms.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14.5. Arbitration: All disputes, differences or claims arising out of
          or in connection with these Terms, shall be referred upon to a sole
          arbitrator (to be mutually agreed between the parties) and finally
          settled in accordance with the rules of the Arbitration and
          Conciliation Act, 1996. The seat and venue of arbitration shall be
          Mumbai and shall be conducted in English language.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14.6. Anti Bribery And Sanctions Laws: You agree to comply with all
          applicable anti-bribery and anti corruption laws which prohibit
          officials, representatives, agents or any other person associated with
          or acting on behalf of You from giving, offering, promising to offer,
          receiving/ accepting or acting in any other manner so as to induce a
          payment, gift, hospitality or anything else of value (either directly
          or indirectly) whether from within the country or from abroad to
          government officials, public servants, regulatory bodies, judicial
          authorities, persons in positions of authority, elected or contesting
          electoral candidates, political parties or office bearers thereof or
          any other third party or person in order to obtain an improper
          commercial/ business advantage of any kind. Government officials
          include any government employee, candidate for public office, an
          employee of government- owned or government–controlled companies,
          public international organisations and political parties. You also
          agree not to give, offer, pay, promise or authorise to give or pay,
          directly, indirectly or through any other person, of anything of value
          to anybody for the purpose of inducing or rewarding any favourable
          action or influencing any decision in Your favour.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>PART B: SPECIFIC TERMS OF USE OF MERCHANT SERVICES </b>
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          1. Financial Products Facilitation Services is a proposition enabled
          by InstaPe Synergies Private Limited ("InstaPe") on the InstaPe mobile
          application or on our websites (together referred to as the “InstaPe
          App"), under which InstaPe facilitates the Financial Products through
          certain financing partner/lender(s) ("Merchants") to selected
          customers of InstaPe ("You") in accordance with the terms of relevant
          investment products or financing schemes being made available by such
          Merchants to You ("Financial Products Facilitation Services" or
          “Services”).
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          2. You shall be offered any relevant loan products/salary advance
          products ("Loan Products") as part of the Financial Products
          Facilitation Services only if you are eligible to avail such loan
          products, whose eligibility shall be determined by the Merchants at
          their sole discretion, however the decision on Your acceptance as a
          Borrower, loan sanction and subsequent disbursals shall rest solely
          with the Merchants only. InstaPe and its employees/ representatives/
          agents / service providers shall not be responsible/liable in any
          manner whatsoever to You for rejection of your application by the
          Merchants or guarantee loan sanctions.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          3. By registering and using the Financial Products Facilitation
          Services, you hereby represent and warrant to InstaPe and the Merchant
          that you are 18 years of age or older, and that you have the authority
          and capacity to avail the Financial Products being offered through the
          Financial Products Facilitation Services and agree to abide by these
          terms and conditions.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          4. You understand that the access to and use of the Financial Products
          Facilitation Services are conditional upon your acceptance of and
          continuous compliance with these terms and conditions set herein at
          all times, as well as the Terms of Use and Privacy Policy of InstaPe
          and the relevant Merchant, and other relevant documentation of
          Merchants, including any modifications, alterations or updates
          thereof, that are published on the InstaPe App or the Merchant’s
          platform.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          5. You understand that by accepting, the respective Merchants’ terms
          and conditions, their privacy policy, specific product terms, You are
          entering into a legally binding contract with the respective Merchant.
          You understand and agree that the privity of contract is between You
          and the Merchant and InstaPe is only facilitating the granting access
          to the Financial Products
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          6. You further understand that by choosing to avail the Financial
          Products Facilitation Services, You have availed a service from the
          respective Merchant and You shall be liable to that respective
          Merchant for any default in the dues payable to such Merchant.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          7. You hereby acknowledge and confirm that where You have opted for
          any Loan Product through InstaPe, for repayment of loans and salary
          advances, Your Salary as may be payable to You by your employer, shall
          be used for deducting the amounts due for repayment. In addition, NACH
          or e-NACH mandate provided by You shall be used for recovery of
          amounts dues, in case the loan or salary advance repayment is not made
          through salary deduction by your employer or, You have not completed
          repayment to lending partner of InstaPe through any other mode.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          8. You hereby acknowledge and confirm that where You have opted for
          any fixed deposit with any Merchant through as part of the Services
          provided by InstaPe App, Your deposit will be held with such Merchant
          and not InstaPe. The deposit shall be subject to the terms and
          conditions of the Merchant and InstaPe does not provide any kind of
          guarantee, assurance or commitment of earning any returns on such
          deposits or for return of capital. You agree that InstaPe shall not be
          responsible for any issues with such Merchants and shall be dealt
          directly by such Merchants.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          9. Display of the Financial Products on the InstaPe App as part of
          Services shall not in any way be construed as an offer, advice,
          inducement or suggestion to avail such Financial Products{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          10. InstaPe makes no representations or warranties about the websites
          of the Merchants. InstaPe does not endorse, adopt, or otherwise accept
          any responsibility for the content or use of those websites.{" "}
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          11. InstaPe shall verify your identity whereby InstaPe will retain and
          share with credit bureaus, Merchants and other authorized financial
          institutions the required personal identifiable information about you
          to facilitate your loan application.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          12. InstaPe shall share your details with Merchants to assist you to
          know about the Financial Products.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          13. InstaPe shall provide you with customized recommendations and
          personalized offers of the Financial Products of the Merchants.
        </p>
        <p style={{ paddingLeft: 20, textAlign: "justify" }}>
          14. InstaPe shall send to You
          information/analysis/reports/personalized offers via email, text, SMS,
          WhatsApp message, telephonic call or online display or other means of
          delivery in InstaPe’s reasonable sole discretion.
        </p>
      </div>
    </>
  );
};

export default Terms;
